import { Link } from "react-router-dom";
import { ShieldCheck, Clock, Eye, Handshake, ArrowRight } from "lucide-react";
import { PageHero } from "@/components/site/PageHero";
import { COMPANY } from "@/lib/company";

const VALUES = [
  { icon: ShieldCheck, title: "Affidabilità", text: "Trattiamo ogni carico come se fosse nostro, con attenzione in tutte le fasi del trasporto." },
  { icon: Clock, title: "Puntualità", text: "Pianifichiamo ritiri e consegne per rispettare i tempi concordati con i clienti." },
  { icon: Eye, title: "Trasparenza", text: "Ogni spedizione è tracciabile online con una cronologia chiara degli aggiornamenti." },
  { icon: Handshake, title: "Collaborazione", text: "Costruiamo rapporti di lavoro duraturi basati su comunicazione diretta e chiarezza." },
];

export default function About() {
  return (
    <>
      <PageHero eyebrow="Chi siamo" title={COMPANY.name} text="Trasporti, spedizioni e logistica dalla nostra sede di Taranto." image="/images/blacktruck.jpg" />
      <section className="bg-[#0B0C0E] py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-7 space-y-5 text-slate-300 leading-relaxed" data-testid="about-text">
            <h2 className="font-display text-3xl sm:text-4xl font-extrabold uppercase tracking-tight text-white">La tua merce, la nostra responsabilità.</h2>
            <p>{COMPANY.name} opera nel settore dei trasporti, delle spedizioni e della logistica, con sede in {COMPANY.street}, {COMPANY.cap} {COMPANY.city}.</p>
            <p>Il nostro lavoro è portare a destinazione la merce dei clienti in modo sicuro e organizzato, mantenendo sempre informati mittenti e destinatari sullo stato di ogni spedizione.</p>
            <p>Per questo abbiamo realizzato una piattaforma di tracciamento dedicata: ogni spedizione riceve un codice univoco e ogni fase registrata dal nostro personale è consultabile online, senza registrazione.</p>
            <Link to="/contatti" className="inline-flex items-center gap-2 mt-4 bg-[#E50914] hover:bg-[#C10710] text-white px-6 py-3 font-display font-bold uppercase tracking-wider transition-colors" data-testid="about-contact-btn">
              Contattaci <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
          <div className="lg:col-span-5">
            <img src="/images/loading.jpg" alt="Carico merci" className="w-full aspect-[4/5] object-cover" />
          </div>
        </div>
      </section>
      <section className="bg-black py-24 speed-lines">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[#E50914]">I nostri valori</p>
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
            {VALUES.map((v) => (
              <div key={v.title} className="bg-[#0B0C0E] p-8">
                <v.icon className="h-7 w-7 text-[#E50914]" />
                <h3 className="mt-5 font-display text-xl font-bold uppercase text-white">{v.title}</h3>
                <p className="mt-2 text-sm text-slate-400">{v.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
